export const imageUploadErrorText =
  "エラーが発生しました。\n\n以下の画像はアップロードできません。\n・拡張子が「.png」「.jpg」「.jpeg」以外\n・20MB以上\n・幅460 × 高さ345ピクセル以下\n（アップロードはネットワークに接続した状態で行ってください）";
export const maxUploadableImagesErrorText =
  "エラーが発生しました。\n\n一括でアップロードできるファイル上限数は25枚です。";

// フロントエンドで、画像をサーバーにアップロードする前に制御しておきたいバリデーションを行う
// 以下URLのコードのように厳密なバリデーションを行っても良いが、既存のclient_image_select_modal.jsでは行われずに運用できているので今回はスルーする。ただし画像サイズの最大値チェックは行わないとサーバーダウンの危険性もあるので最低限行う
// https://github.com/rejob/rejob-v2/blob/4ca292a4dd60be3f8c75739b46472c9ef8758e77/app/packs/legacy/user_frontend/components/pages/mypage/profiles/product_photo_edit/ui_parts/image_uploader.tsx#L78-L109

// 20MB = 20 * 1024 * 1024 bytes
const imageUploadMaxSizeInBytes = 20 * 1024 * 1024;
export const isValidUploadImage = (file: File): boolean => {
  if (file.size >= imageUploadMaxSizeInBytes) return false;

  return true;
};
